import { render, staticRenderFns } from "./AppAlertsDialogVehicleDetails.vue?vue&type=template&id=1a6004d7&scoped=true&"
import script from "./AppAlertsDialogVehicleDetails.vue?vue&type=script&lang=js&"
export * from "./AppAlertsDialogVehicleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6004d7",
  null
  
)

export default component.exports